import { YA_MAP_URL } from "./config";
import { addScript } from "../utils";

/**
 * @function getYandexMap - выполняет скрипт для инициализации карты
 * @param {Function} initialize - функция инициализации карты
 * @param {Function} errorHandler - обработчик ошибки
 * */

export default async function getYandexMap(initialize, errorHandler) {
    try {
        const response = await fetch(YA_MAP_URL);
        const scriptContent = await response.text();
        await addScript(scriptContent, true);
        initialize();
    } catch (error) {
        errorHandler(error);
    }
}
